import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { FooterTopComponent } from '../../../app/content/layout/components/general/footer/components/footer-top/footer-top.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<FooterTopComponent> = {
  title: 'Organisms/Footer/Footer Top',
  component: FooterTopComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
  parameters: {
    backgrounds: { default: 'dark', values: [{ name: 'dark', value: '#1a1a2e' }] },
  },
};
export default meta;
type Story = StoryObj<FooterTopComponent>;

export const Default: Story = {
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-footer-top')).toBeTruthy();
  },
};
